<template>
  <div class="">
    <top-header
      :type="6"
      hasBorder="true"
      placeholder="修改密码"
      fontSize="0.32rem"
    />
    <van-form @submit="onSubmit" validate-trigger="onSubmit">
      <h4>商品房合同新密码</h4>
      <van-field
        v-model="old"
        name="realName"
        type="password"
        label=""
        placeholder="请输入6-10位密码"
        :rules="[{ validator: testPwd, message: '请填写正确的商品房合同新密码' }]"
      />
      <h4>再输入一次商品房合同新密码</h4>
      <van-field
        v-model="newPwd"
        name="realName"
        type="password"
        label=""
        placeholder="请再输入一次密码"
        :rules="[{ validator: testNew, message: '密码不一致' }]"
      />
      <div class="btn_con">
        <van-button block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
let timmer = null;
import qs from 'qs';
import topHeader from '@/components/header';
export default {
  data() {
    return {
      old: '',
      newPwd: ''
    };
  },
  components: {
    topHeader
  },
  mounted() {

  },
  methods: {
    testPwd (data) {
      if(data.length < 6 || data.length > 10) {
        return false
      } else {
        return true
      }
    },
    testNew (data) {
      if(data != this.old) {
        return false
      } else {
        return true
      }
    },
    onSubmit(values) {
      this.$http.post('cms/sPFContractSignArea/reg/changePwd.do', qs.stringify({
        contractRecordNo: this.$route.query.contractRecordNo,
        area: this.$route.query.area,
        pwd: values.realName,
      })).then(res => {
        if(res.success) {
          this.$toast(res.msg);
        }else{
          this.$toast(res.msg);
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>
h3{
  font-size: 0.36rem;
  font-weight: 800;
  padding: 0 16px;
  margin: 0 auto 0.6rem;
}
h4{
  padding: 0.4rem 16px 0.1rem;
  font-size: 15px;
  font-weight: 800;
}
.form_con{
  padding: 0.3rem 0rem;
}
.btn_con{
  background-color: #fff;
  padding: 0.4rem 0;
  left: 0;
  right: 0;
  /deep/
  .van-button{
    height: 0.88rem;
    width: 7.04rem;
    margin: 0 auto;
    border-radius: 0.08rem;
  }
}
</style>